import { render, staticRenderFns } from "./video-button.vue?vue&type=template&id=0722ba5a"
import script from "./video-button.vue?vue&type=script&lang=js"
export * from "./video-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports